
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceNumberFormatDialog extends Serenity.EntityDialog<InvoiceNumberFormatRow, any> {
        protected getFormKey() { return InvoiceNumberFormatForm.formKey; }
        protected getIdProperty() { return InvoiceNumberFormatRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceNumberFormatRow.localTextPrefix; }
        protected getNameProperty() { return InvoiceNumberFormatRow.nameProperty; }
        protected getService() { return InvoiceNumberFormatService.baseUrl; }
        protected getDeletePermission() { return InvoiceNumberFormatRow.deletePermission; }
        protected getInsertPermission() { return InvoiceNumberFormatRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceNumberFormatRow.updatePermission; }

        protected form = new InvoiceNumberFormatForm(this.idPrefix);

    }
}